import { CloseIcon, HeaderContainer, HeaderLabel, StyledModal } from '../MyOrdersStyle';
import { Modal } from '@mui/material';
import { PropsWithChildren } from 'react';

export interface UpdateModalProps extends PropsWithChildren {
  open: boolean;
  ariaLabel: string;
  headerLabel: string;
  closeModal: () => void;
}

export function UpdateModal({
  open,
  ariaLabel,
  headerLabel,
  closeModal,
  children,
}: UpdateModalProps) {
  return (
    <Modal className='modal-container' open={open} onClose={closeModal} aria-labelledby={ariaLabel}>
      <StyledModal>
        <HeaderContainer>
          <HeaderLabel>{headerLabel}</HeaderLabel>
          <CloseIcon onClick={closeModal}>X</CloseIcon>
        </HeaderContainer>
        {children}
      </StyledModal>
    </Modal>
  );
}
